import FileInputUploadFieldNew from 'components/styledFormElements/FineInputUploadNew'
import InputField from 'components/styledFormElements/InputField'
import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useObjectUrl } from 'hooks/useObjectUrl'
import { getImageSrc } from 'services/util'

const VoiceAssistantConfig = () => {
  const prefix = 'voice_assistant_header' as const

  const {
    control,
    register,
    formState: { errors },
  } = useFormContext<any>()

  const watchedImage = useWatch({ control, name: `${prefix}.image` })
  const imagePreview = useObjectUrl(watchedImage)

  return (
    <div className="space-y-4 flex-1 flex flex-col">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 flex-1">
        {/* Image */}
        <FileInputUploadFieldNew
          label="Image"
          name={`${prefix}.image`}
          control={control}
          errors={errors}
          preview={getImageSrc(imagePreview)}
          allowedTypes={['image/jpeg', 'image/png', 'image/jpg']}
          required
          rules={{
            required: 'Image is required',
          }}
          tooltip={{
            title: 'Image requirements',
            items: [
              'Upload the image displayed at the top of the Voice Assistant screen',
              'JPG / PNG',
              '≤ 1 MB'],
            position: 'top',
          }}
        />

        {/* Heading */}
        <InputField
          label="Heading"
          type="text"
          required
          helpText="Enter the main title shown on the Voice Assistant screen."
          maxLength={100}
          register={register(`${prefix}.heading`, {
            required: 'Heading is required',
            maxLength: {
              value: 100,
              message: 'Heading must be 100 characters or less',
            },
          })}
          error={(errors[prefix] as any)?.heading?.message as string}
        />

        {/* Description */}
        <InputField
          label="Description"
          isTextarea
          row={2}
          required
          helpText="Add a short supporting description displayed below the header on the Voice Assistant screen"
          maxLength={500}
          register={register(`${prefix}.description`, {
            required: 'Description is required',
            maxLength: {
              value: 500,
              message: 'Description must be 500 characters or less',
            },
          })}
          error={(errors[prefix] as any)?.description?.message as string}
        />

        {/* CTA Label */}
        <InputField
          label="CTA Label"
          type="text"
          required
          helpText="Label for the call-to-action button shown on the Voice Assistant header."
          maxLength={50}
          register={register(`${prefix}.cta_label`, {
            required: 'CTA Label is required',
            maxLength: {
              value: 100,
              message: 'CTA Label must be 100 characters or less',
            },
          })}
          error={(errors[prefix] as any)?.cta_label?.message as string}
        />
      </div>
    </div>
  )
}

export default VoiceAssistantConfig
